export const OBSERVABILITY_PROMQL_VARIABLES = ["__interval", "__rate_interval"] as const;

export type ObservabilityPromQLVariable = (typeof OBSERVABILITY_PROMQL_VARIABLES)[number];
